import { html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import { AttentionIconName } from '../../ui-icons/ui-attention-icon';
import type { UIModal } from '../../ui-modal/ui-modal';
import styles from './ui-logout-modal.css?inline';

const CName = 'ui-logout-modal';

@customElement(CName)
export class UILogoutModal extends UIModalServiceModal {
  static readonly styles = unsafeCSS(styles);

  public close() {
    this._modalRef.value?.close();
  }

  render() {
    return html`
      <ui-modal
        ${ref(this._modalRef)}
        .isDismissible=${true}
        .actionButtonLabel=${window.$app.$t.get(I18n.mod.account.logout.cta)}
        .onAction=${(e: UIModal) => {
          e.close();
        }}
        .onAltAction=${(e: UIModal) => {
          e.close();
          window.$app.logout();
        }}
        .altActionButtonVariant=${'secondary-outlined'}
        .altActionButtonLabel=${window.$app.$t.get(I18n.mod.account.logout.logout)}
        class="modal--centered"
      >
        <div slot="title">
          <div class="stop">
            <ui-attention-icon .name=${AttentionIconName.INFORMATION} class="size-xxl"></ui-attention-icon>
          </div>
          ${window.$app.$t.get(I18n.mod.account.logout.title)}
        </div>
        <div class="content" slot="main">
          <div>${window.$app.$t.get(I18n.mod.account.logout.subtitle)}</div>
        </div>
      </ui-modal>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UILogoutModal;
  }
}
